import {
  Text,
  TextSize,
  TextWeight,
  TipPlacement,
  Tooltip,
  makeStyles
} from '@focaldata/cin-ui-components'
import { useState } from 'react'
import EditProjectName from './EditProjectName'

const useStyles = makeStyles()({
  // reset so a native (accessible) <button> can carry the title. Block +
  // max-width so a clamped container (the subheader) still truncates the name.
  titleButton: {
    display: 'block',
    maxWidth: '100%',
    overflow: 'hidden',
    background: 'none',
    border: 'none',
    padding: 0,
    font: 'inherit',
    textAlign: 'left',
    cursor: 'pointer'
  }
})

interface Props {
  name: string
  // Renaming is offered only once the project is known: public results renders
  // the title from metadata, with no project to rename.
  projectId?: string
  size?: TextSize
  weight?: TextWeight
  noWrap?: boolean
}

/**
 * The project title, wherever it is shown — click it to rename. Callers own
 * the surrounding layout (subheader row, page heading) and the text size.
 */
export const EditableProjectTitle = ({
  name,
  projectId,
  size,
  weight,
  noWrap
}: Props) => {
  const { classes } = useStyles()
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const title = (
    <Text size={size} weight={weight} noWrap={noWrap} dataCy="project-title">
      {name}
    </Text>
  )

  if (!projectId) {
    return title
  }

  return (
    <>
      <Tooltip title="Edit project title" tipPlacement={TipPlacement.TopStart}>
        <button
          type="button"
          className={classes.titleButton}
          onClick={() => setIsDialogOpen(true)}
        >
          {title}
        </button>
      </Tooltip>
      {isDialogOpen && (
        <EditProjectName
          selectedProjectId={projectId}
          selectedProjectName={name}
          isDialogOpen={isDialogOpen}
          setIsDialogOpen={setIsDialogOpen}
        />
      )}
    </>
  )
}
